import { graphql } from '@/generated/gql';

export const NEGOTIATION_CASE_CREATE_MUTATION = graphql(/* GraphQL */ `
  mutation NegotiationCaseManualCreate($data: TsrctDemandInput!) {
    tesseract {
      demandCreate(data: $data) {
        id
        negotiationCases {
          nodes {
            id
          }
        }
      }
    }
  }
`);
